import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LeftTree from "../components/LeftTree.vue";
import { StatisticsServiceProxy } from "@/service-proxies/app-v2/mdc.service-proxies";
import { exportOutput, exportEnergy } from '@/api/api';
const ssp = new StatisticsServiceProxy();
enum RENDER_METHODS {
  Table,
  Bar,
}

@Component
class Bar extends Vue {
  @Prop({ default: () => [] }) readonly dataValue: any;
  @Prop({ default: () => [] }) readonly columns: any;
  myChart = null;
  mounted() {
    this.init();
  }

  @Watch("dataValue", { deep: true })
  init() {
    console.log(this.dataValue)
    const {
      workStation: { workStationName },
      data,
    } = this.dataValue;
    const keys = Object.keys(data).sort();

    const seriesData = [
      {
        data: keys.map((key) => data[key]),
        type: "bar",
        label: {
          show: true,
          position: "top",
        },
      },
    ];

    const options = {
      tooltip: {
        trigger: "axis",
      },
      grid: {
        left: "30",
        right: "10%",
        bottom: "4%",
        top: "30",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        axisLabel: {
          show: true,
          interval: 0,
          rotate: -35,
        },
        axisLine: { onZero: true },
        data: this.columns.map((item) => item.title),
      },
      series: seriesData,
      yAxis: [
        {
          // name: workStationName,
          type: "value",
        },
      ],
    };
    var myChart = (this as any).$echarts.init(this.$refs.myChart as any);
    myChart.setOption(options);

    this.myChart = myChart;
  }

  mathDataLength() {
    return (90 / this.dataValue.length).toFixed(2);
  }

  render() {
    return <div ref="myChart" style="height:300px"></div>;
  }
}

@Component({
  components: {
    LeftTree,
    Bar
  }
})
class ProductivityAnalysis extends Vue {
  columns = [];
  operationData = [];
  showType = 1;
  tabIndex = 0;
  loading = false;
  searchValue:any = {};
  xwidth = 2000
  filterType = 'yield'

  render() {
    return (
      <a-layout style="height: 100%">
        <a-layout-sider
          width="360"
          style="background: #fff; min-width:360px; overflow:auto;"
          class="no-fix-sider"
        >
          {this.renderLeftTree()}
        </a-layout-sider>
        <div v-resize={"x"}></div>
        <a-layout-content style={{ height: "100%" }}>
          {this.renderBody()}
        </a-layout-content>
      </a-layout>
    );
  }

  renderLeftTree() {
    return (
      <left-tree
        init={["statistical", "shift", "time", "Tree.vue"]}
        onSearch={(value) => this.search(value)}
        onOutPut={() => this.outPut()}
        queryKey="productivity-analysis"
      ></left-tree>
    );
  }

  outPut() {}

  async search(value) {
    delete value.productivityType;
    this.searchValue = {...value}
    this.loading = true;
    let fn = this.filterType === 'yield' ? ssp.outputStatistics(value) : ssp.getElectricityStatistics(value)
    try {
      const { columns, items } = await fn;

      let arr = [];

      for(var i=0; i<value.workStationList.length; i++) {
        for(var j=0; j<items.length; j++) {
          if(value.workStationList[i].key == items[j].workStation.workStationId) {
            arr.push(items[j])
          }
        }
      }

      this.columns = columns;
      // this.operationData = items;
      this.operationData = arr;
        this.xwidth = (this.columns.length+1)*108
      console.log(8888,this.xwidth,this.columns.length+1)
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  async export() {
    let exportFn = this.filterType === 'yield' ? exportOutput(this.searchValue) : exportEnergy(this.searchValue)
    const res = await exportFn
    // 创建隐藏的可下载链接
    var a = document.createElement('a')
    a.download = `${this.$t('page_productivity_analysis')}.xlsx`
    a.style.display = 'none'
    // 字符内容转变成blob地址
    // var blob = new Blob([res])
    let url = URL.createObjectURL(res)
    a.href = url
    // 触发点击
    document.body.appendChild(a)
    a.click()
    // 然后移除
    URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  renderBody() {
    return (
      <blank-view>
        <div slot="action" style="display: flex; justify-content: space-between;">
          <a-button type="primary" onClick={() => this.export()}>{this.$t('page_product_export')}</a-button>
          <a-radio-group v-model={this.showType} onChange={this.toggleChartType}>
            <a-radio-button value={1}>
              {this.$t("page_operation_statistics_barchart")}
            </a-radio-button>
            <a-radio-button value={0}>
              {this.$t("page_operation_statistics_tablechart")}
            </a-radio-button>
          </a-radio-group>
        </div>
        {this.loading ? (
          <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
            <a-spin />
          </div>
        ) : (
          this.renderContent()
        )}
      </blank-view>
    );
  }

  //切换显示数据表或柱状图
  toggleChartType() {
    this.filterType = 'yield'
    this.search(this.searchValue)
  }

  //数据表下切换显示：能耗（energy）；产量（yield）
  toggleFilterType(val) {
    this.filterType = val.target.value
    this.search(this.searchValue)
  }

  renderTable() {
    const columns = this.columns.map(({ code, title }) => ({
      title: title,
      dataIndex: code,
      width: 50,
    }));
    columns.unshift({
      title: this.$t("page_workstation_name"),
      dataIndex: "title",
      width: 80,
    });

    const dataSource = this.operationData.map((item) => ({
      title: item.workStation.workStationName,
      ...item.data,
    }));
    return (
      <div ref="" style="height: 100%;">
        <a-radio-group value={this.filterType} onChange={this.toggleFilterType} style="margin-bottom: 8px;">
          <a-radio-button value="yield"> {/*产量*/}
            { this.$t('page_card_output_volume') }
          </a-radio-button>
          <a-radio-button value="energy"> {/*能耗*/}
            { this.$t('page_card_energy_consumption') }
          </a-radio-button>
        </a-radio-group>
      <ml-table
        size="small"
        columns={columns}
        defaultExpandAllRows={true}
        dataSource={dataSource}
        canChangeColWidth={true}
        canFixedHead={true}
        scroll={{ x: this.xwidth, y: 750 }}
        isAutoWidth={true}
      ></ml-table>
      </div>
    );
  }

  renderBar() {
    return (
      <div>
        {this.operationData.map((data) => (
          <div>
            <div style="padding-top: 5px;padding-left: 18px">{data.workStation.workStationName}</div>
            <Bar dataValue={data} columns={this.columns} ref="bar" />
          </div>
        ))}
      </div>
    );
  }

  renderContent() {
    const renderMethod = `render${RENDER_METHODS[this.showType]}`;
    return this[renderMethod]();
  }

  changeTabs(value) {
    // console.log(value);
  }
}

export default ProductivityAnalysis;
